/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-15 10:34:10
 * @FilePath: /unifyxp-v2-store-portal/src/request/common/hsCode.ts
 */
import { post } from 'src/tools/server';
//portal/stockSupplie
import { IListResponse, IHscode } from 'src/types/common/common';
const addSupplier = (
  startIndex,
  pageCount,
  body,
): Promise<IListResponse<IHscode[]>> => {
  return post(`/portal/hsCode/${startIndex}/${pageCount}`, body, {});
};

const getProductsByHsCode = (body) => {
  ///portal/products/searchByHsCode
  return post(`/portal/products/searchByHsCode`, body, {});
};
export { addSupplier, getProductsByHsCode };
